import React from "react";
import { usePusher } from "../../hooks/usePusher";

function PusherInitializer() {
  usePusher();

  // This component doesn't render anything, it just initializes Pusher
  return null;
}

export default PusherInitializer;
